import { Timestamp } from 'firebase/firestore';
import {
  FirestoreEntity,
  Mapper,
  TeamGroup,
  TeamGroupDto,
  TeamGroupEntity,
  TimestampDtoToTimestampMapper,
} from '../../..';

export class TeamGroupToTeamGroupEntityMapper
  implements Mapper<TeamGroup, FirestoreEntity<TeamGroupEntity>>
{
  public map(from: TeamGroup): FirestoreEntity<TeamGroupEntity> {
    return new FirestoreEntity(from.id, {
      _version: 0,
      createdAt: Timestamp.fromDate(from.createdAt),
      email: from.email,
      name: from.name,
      teamId: from.teamId,
      users: from.users,
    });
  }
}

export class TeamGroupDtoToTeamGroupEntityMapper
  implements Mapper<TeamGroupDto, FirestoreEntity<TeamGroupEntity>>
{
  private readonly timestampMapper = new TimestampDtoToTimestampMapper();

  public map(from: TeamGroupDto): FirestoreEntity<TeamGroupEntity> {
    return {
      id: from.id,
      data: {
        ...from.data,
        createdAt: this.timestampMapper.map(from.data.createdAt),
      },
    };
  }
}

export class TeamGroupEntityToTeamGroupMapper
  implements Mapper<FirestoreEntity<TeamGroupEntity>, TeamGroup>
{
  public map(from: FirestoreEntity<TeamGroupEntity>): TeamGroup {
    return new TeamGroup(
      from.id,
      from.data.createdAt.toDate(),
      from.data.email,
      from.data.name,
      from.data.teamId,
      from.data.users,
    );
  }
}
